import React from 'react';

const CartHeader = ({
  cartLength,
  categories,
  selectedCategory,
  onCategoryChange,
  onlyAvailable,
  onOnlyAvailableChange,
  quickProducts,
  onQuickProductAdd,
  onSaveDraft,
  onClearCart,
  customerSection
}) => {
  return (
    <div
      style={{
        padding: "0.5rem 0.75rem",
        borderBottom: "1px solid var(--border)",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "0.5rem",
        backgroundColor: "var(--bg)"
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
        }}
      >
        <span style={{ fontSize: "1rem" }}>🛒</span>
        <div>
          <h6
            style={{
              margin: 0,
              fontSize: "12px",
              fontWeight: "600",
              color: "var(--text)",
            }}
          >
            Koszyk
          </h6>
          <p
            style={{
              margin: 0,
              fontSize: "10px",
              color: "var(--text-muted)",
            }}
          >
            {cartLength} {cartLength === 1 ? "produkt" : "produktów"}
          </p>
        </div>

        {/* Separator */}
        <div style={{ width: "1px", height: "24px", backgroundColor: "var(--border)", marginLeft: "0.25rem" }} />

        {/* Klient — inline */}
        {customerSection && (
          <div style={{ display: "flex", alignItems: "center" }}>
            {customerSection}
          </div>
        )}

        {/* Filtry w jednej linii z nagłówkiem */}
        <div
          style={{
            display: "flex",
            gap: "0.5rem",
            alignItems: "center",
            marginLeft: "0.25rem",
            flexWrap: "wrap",
          }}
        >
          {/* Kategoria */}
          <div style={{ minWidth: "120px" }}>
            <select
              value={selectedCategory}
              onChange={(e) => onCategoryChange(e.target.value)}
              style={{
                width: "100%",
                padding: "6px 10px",
                fontSize: "12px",
                border: "1px solid var(--border)",
                borderRadius: "6px",
                backgroundColor: "var(--card-bg)",
                color: "var(--text)",
                boxSizing: "border-box",
              }}
            >
              <option value="">🏷️ Wszystkie</option>
              {categories.map((category, index) => (
                <option key={index} value={category.name}>
                  {category.name} ({category.product_count || 0})
                </option>
              ))}
            </select>
          </div>

          {/* Widok */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "6px 10px",
              fontSize: "12px",
              border: "1px solid var(--border)",
              borderRadius: "6px",
              backgroundColor: "var(--card-bg)",
            }}
          >
            <input
              type="checkbox"
              id="onlyAvailableCart"
              checked={onlyAvailable}
              onChange={(e) => onOnlyAvailableChange(e.target.checked)}
              style={{ marginRight: "0.3rem" }}
            />
            <label
              htmlFor="onlyAvailableCart"
              style={{
                margin: 0,
                fontSize: "11px",
                color: "var(--text-secondary)",
              }}
            >
              ✓ Dostępne
            </label>
          </div>

          {/* Szybkie produkty - przyciski szybkiego dodawania */}
          {quickProducts.length > 0 && (
            <div
              style={{
                display: "flex",
                gap: "0.3rem",
                alignItems: "center",
                marginLeft: "0.3rem",
                paddingLeft: "0.5rem",
                borderLeft: "1px solid var(--border)",
              }}
            >
              {quickProducts.map((qp) => (
                <button
                  key={qp.id}
                  data-pos-btn="true"
                  onClick={() => onQuickProductAdd(qp)}
                  title={`${qp.product_nazwa || qp.nazwa} - ${(qp.product_cena || 0).toFixed(2)} zł`}
                  style={{
                    padding: "4px 10px",
                    fontSize: "11px",
                    border: "1px solid var(--purple)",
                    backgroundColor: "var(--purple-light)",
                    color: "var(--purple)",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.3rem",
                    whiteSpace: "nowrap"
                  }}
                >
                  <i className={qp.ikona || "fas fa-shopping-bag"}></i>
                  {qp.nazwa}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      <div style={{ display: "flex", gap: "0.3rem" }}>
        {cartLength > 0 && (
          <>
            <button
              data-pos-btn="true"
              onClick={onSaveDraft}
              style={{
                padding: "4px 10px",
                fontSize: "11px",
                border: "1px solid var(--text-muted)",
                backgroundColor: "var(--card-bg)",
                color: "var(--text-muted)",
              }}
              title="Zapisz jako szkic"
            >
              💾 Szkic
            </button>
            <button
              data-pos-btn="true"
              onClick={onClearCart}
              style={{
                padding: "4px 10px",
                fontSize: "11px",
                border: "1px solid var(--danger)",
                backgroundColor: "var(--card-bg)",
                color: "var(--danger)",
              }}
              title="Wyczyść koszyk"
            >
              🗑️ Wyczyść
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default React.memo(CartHeader);
